var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"AccountMT"},[_c('page-header',{attrs:{"title":"アカウント設定"}}),_c('div',{staticClass:"AccountMT__content"},[_c('account-form')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }